var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{class:[
        _vm.$style.heightClss,
        _vm.$vuetify.breakpoint.smAndDown ? 'pt-0 pb-2' : '',
        _vm.$vuetify.breakpoint.xs ? 'pt-6 pb-2' : '' ],attrs:{"cols":"12"}},[(_vm.isableSymptomCheckerURL)?_c('iframe',{class:[
          _vm.$style.noBorder,
          _vm.$vuetify.breakpoint.smAndDown ? 'mt-1' : ' ' ],attrs:{"id":"sc-iframe","src":_vm.isableSymptomCheckerURL,"frameborder":"0","title":"Isabel Symptom Checker"}}):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }